import { useEffect } from 'react';
import { getParsedJwt, getTokens } from 'modules/oauth/tokenStore';
import { useTrainLabelSuggestionsMutation } from 'graphql/types';

export const useTriggerMlTraining = (): void => {
  // trigger ml training for sample dbs for now
  // TODO this will be improved part of TIDP-815

  const token = getTokens();
  const value = getParsedJwt(token?.accessToken);
  const accountType = value?.['replicon:account_type'];
  const user = value?.sub;

  const [trainLabelSuggestions] = useTrainLabelSuggestionsMutation();

  useEffect(() => {
    if (
      localStorage.getItem('new-login') &&
      accountType === 'urn:replicon-saas:account-type:trial' &&
      user
    ) {
      trainLabelSuggestions({
        variables: { user: user }
      });
    }
  }, [accountType, trainLabelSuggestions, user]);
};
